<app-loader></app-loader>
<mat-sidenav-container class="h-100">
    <mat-sidenav #snav position="end" mode="over" role="navigation">
        <app-navigation></app-navigation>
    </mat-sidenav>
    <mat-sidenav-content class="d-flex flex-column" role="main">
        <app-header [nav]="snav"></app-header>
        <main>
        <router-outlet></router-outlet>
        </main>
        <app-footer></app-footer>
    </mat-sidenav-content>
</mat-sidenav-container>